import {
  ArrowForwardIosOutlined,
  Cancel,
  Search,
  TurnLeft,
  VisibilityOffOutlined,
} from "@mui/icons-material";
import {
  Drawer,
  Tab,
  Tabs,
  Paper,
  FormControl,
  OutlinedInput,
  InputAdornment,
  IconButton,
  TextField,
  Box,
  Typography,
  Link,
  Dialog,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import React, { useEffect, useRef, useState } from "react";
import defaultImg from "../../assets/svg/defultImage.svg";
import "./OtherServices.css";
import axios from "axios";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { DataGrid } from "@mui/x-data-grid";
import noData from "../../assets/svg/Emptyfile1.svg";
import { Form } from "react-bootstrap";
import { DateTimePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import dayjs from "dayjs";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import InfoIcon from "@mui/icons-material/Info";
import { newHost } from "../../pages/Categories/CategoryProfile";
import { newImageUrl } from "../../pages/Manufacturers/ManufactureProfile";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import cameraIcon from "../../assets/svg/Camera icon.svg";
import CancelIcon from "@mui/icons-material/Cancel";
import DatePickerDMY from "../DatePickerDMY";
import { useParams } from "react-router";
import { database } from "../../firebase";
import { Tooltip } from "@mui/material";
import {
  ref,
  query,
  limitToLast,
  onChildAdded,
  onChildChanged,
} from "firebase/database";
import MarkAllAsRead from "../SharedModule/MarkAllAsRead";

export const ReadMoreChars = ({ text, maxChars = 120 }) => {
  const [expanded, setExpanded] = useState(false);

  if (!text) return null;

  const isLong = text.length > maxChars;

  return (
    <Typography
      variant="body1"
      className=""
      sx={{
        lineHeight: 1.6,
        whiteSpace: "normal",
        wordBreak: "break-word",
        overflowWrap: "anywhere",
      }}
    >
      {expanded || !isLong ? text : `${text.slice(0, maxChars)}...`}

      {isLong && (
        <Link
          component="button"
          underline="none"
          onClick={() => setExpanded(!expanded)}
          sx={{ ml: 1, fontSize: 13, fontWeight: 800, color: "#000000" }}
        >
          {expanded ? "Read less" : "Read more"}
        </Link>
      )}
    </Typography>
  );
};

export const ReadMoreTitle = ({ text, maxChars = 100 }) => {
  const [expanded, setExpanded] = useState(false);

  if (!text) return null;

  const isLong = text.length > maxChars;

  return (
    <Typography
      variant="body1"
      className=""
      sx={{
        lineHeight: 1.6,
        whiteSpace: "normal",
        wordBreak: "break-word",
        overflowWrap: "anywhere",
        fontWeight: "550",
        marginBlock: "10px",
      }}
    >
      {expanded || !isLong ? text : `${text.slice(0, maxChars)}...`}

      {isLong && (
        <Link
          component="button"
          underline="none"
          onClick={() => setExpanded(!expanded)}
          sx={{ ml: 1, fontSize: 13, fontWeight: 800, color: "#000000" }}
        >
          {expanded ? "Read less" : "Read more"}
        </Link>
      )}
    </Typography>
  );
};

const LimitedTextarea = ({
  labelId,
  value,
  onChange,
  maxLength = 500,
  placeholder,
  rows = 3,
  className = "",
}) => {
  const isOverLimit = value?.length > maxLength;

  return (
    <div className="w-100 my-1">
      <textarea
        id={labelId}
        rows={rows}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        className={className}
        style={{
          padding: 10,
          borderRadius: 5,
          // border: `2px solid ${isOverLimit ? "red" : "#D8D8D8"}`,
          width: "100%",
        }}
      />
      <div className="d-flex justify-content-between">
        <small style={{ color: isOverLimit ? "red" : "#666" }}>
          {value?.length || 0}/{maxLength}
        </small>

        {isOverLimit && (
          <small style={{ color: "red" }}>
            You can't enter more than {maxLength} characters
          </small>
        )}
      </div>
    </div>
  );
};

const OtherServices = () => {
  const { user } = useSelector((state) => state.auth);
  const { id } = useParams();
  const token = user?.token;
  // Header
  const [searchQuery, setSearchQuery] = useState("");
  const [filterDate, setFilterDate] = useState("");
  const [filteredRequests, setFilteredRequests] = useState([]);

  // Request Modal

  const [requestShow, setRequestShow] = useState(false);

  const [requestDetails, setRequestDetails] = useState({});

  const handleRequestShow = async (row) => {
    const latestRow = filteredRequests.find((r) => r.id === row.id) || row;
    setRequestDetails(latestRow);

    const draft = sessionStorage.getItem(getDraftKey(row.id));

    if (draft) {
  const parsedDraft = JSON.parse(draft);

  const normalizedServices = parsedDraft.services.map((service) => ({
    ...service,
    ui: {
      isAccepted: service.ui?.isAccepted || false,
      isRejected: service.ui?.isRejected || false,
      productPrice: service.ui?.productPrice || "",
      serviceFee: service.ui?.serviceFee || "",
      notes: service.ui?.notes || "",
      estimated_time: service.ui?.estimated_time || "",
      rejectReason: service.ui?.rejectReason || "",
    },
  }));

  setServices(normalizedServices);
  setExpireDate(
    parsedDraft.expireDate ? dayjs(parsedDraft.expireDate) : dayjs().add(1, "day")
  );
} else {
  const servicesWithUI = row?.services.map((service) => ({
    ...service,
    ui: {
      isAccepted: false,
      isRejected: false,
      productPrice: "",
      serviceFee: "",
      notes: "",
      estimated_time: "",
      rejectReason: "",
    },
  }));

  setServices(servicesWithUI);
  setExpireDate(dayjs().add(1, "day"));
}

    setRequestShow(true);

    if (row.is_read == "0") {
      try {
        await axios.post(
          `${newHost}portal/door_step_request_others/${row.id}/toggle-read`,
          {},
          { headers: { Authorization: `Bearer ${token}` } },
        );
        setUserRequests((prev) =>
          prev.map((r) => (r.id === row.id ? { ...r, is_read: "1" } : r)),
        );
        setNewRequestIds((prev) => {
          const next = new Set(prev);
          next.delete(row.id);
          return next;
        });
        setStatusTransitions((prev) => {
          const next = { ...prev };
          delete next[row.id];
          return next;
        });
        setStatusTransitions((prev) => {
          const next = { ...prev };
          delete next[row.id];
          sessionStorage.setItem("statusTransitions", JSON.stringify(next));
          return next;
        });
        setUpdatedStatusIds((prev) => {
          const next = new Set(prev);
          next.delete(row.id);
          sessionStorage.setItem("updatedStatusIds", JSON.stringify([...next]));
          return next;
        });
      } catch {}
    }
  };

  const handleRequestClose = () => {
    setRequestShow(false);
  };

  //  Accept & Reject

  const handleAccept = (id) => {
    setServices((prev) =>
      prev.map((s) =>
        s.id == id
          ? { ...s, ui: { ...s.ui, isAccepted: true, isRejected: false } }
          : s,
      ),
    );
  };

  const handleReject = (id) => {
    setServices((prev) =>
      prev.map((s) =>
        s.id === id
          ? { ...s, ui: { ...s.ui, isAccepted: false, isRejected: true } }
          : s,
      ),
    );
  };

  const handleReset = (id) => {
    setServices((prev) =>
      prev?.map((s) =>
        s.id == id
          ? {
              ...s,
              ui: {
                isAccepted: false,
                isRejected: false,
                price: "",
                notes: "",
                rejectReason: "",
              },
            }
          : s,
      ),
    );
  };

  // Handle services Request

  const [userRequests, setUserRequests] = useState([]);
  const [services, setServices] = useState([]);
  const [requestStatuses, setRequestStatuses] = useState([]);

  const getUserRequests = async () => {
    try {
      const response = await axios.get(
        `${newHost}portal/door_step_request_others`,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );
      console.log(response);

      setUserRequests(response.data.data.other_requests);
    } catch (error) {
      console.log(error);
    }
  };

  // submit services
  const submitServices = async () => {
    const formData = new FormData();

    services.forEach((service, index) => {
      if (!service.ui.isAccepted && !service.ui.isRejected) return;

      formData.append(`services[${index}][id]`, service.id);

      formData.append(
        `services[${index}][action]`,
        service.ui.isAccepted ? "accepted" : "rejected",
      );

      if (service.ui.isAccepted) {
        formData.append(
          "expire_date",
          expireDate ? dayjs(expireDate).format("YYYY-MM-DD HH:mm:ss") : "",
        );
        formData.append(`services[${index}][product_price]`, service.ui.productPrice);
        formData.append(`services[${index}][service_fee]`, service.ui.serviceFee);
        formData.append(`services[${index}][estbn_notes]`, service.ui.notes);
        formData.append(
          `services[${index}][estimated_time]`,
          service.ui.estimated_time,
        );
        service.ui?.images?.length > 0 &&
          service.ui.images.forEach((file, imgIndex) => {
            formData.append(
              `services[${index}][images][${imgIndex}][image]`,
              file,
            );
          });
      }

      if (service.ui.isRejected) {
        formData.append(
          `services[${index}][reject_reason]`,
          service.ui.rejectReason,
        );
      }
    });

    try {
      const response = await axios.post(
        `${newHost}portal/door_step_request_others/services/${requestDetails.id}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      sessionStorage.removeItem(getDraftKey(requestDetails.id));

      toast.success(response.data.data.message);
      handleRequestClose();
      getUserRequests();
      getRequestStatuses();
    } catch (error) {
      toast.error(error.response.data.message);
    }
  };
  
  // get Statuses

  const getRequestStatuses = async () => {
    try {
      const response = await axios.get(
        `${newHost}portal/door_step_request_others/statuses`,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );
      console.log(response.data.data.statuses);
      setRequestStatuses(response.data.data.statuses);
    } catch (error) {
      console.log(error);
    }
  };

  const handleFileChange = (e, serviceId) => {
    const files = Array.from(e.target.files);
    if (!files.length) return;

    const newPreviews = files?.map((file) => URL.createObjectURL(file));

    setServices((prev) =>
      prev?.map((s) =>
        s.id === serviceId
          ? {
              ...s,
              ui: {
                ...s.ui,
                images: [...(s.ui.images || []), ...files],
                previews: [...(s.ui.previews || []), ...newPreviews],
              },
            }
          : s,
      ),
    );
  };

  const handleRemoveImage = (serviceId, index) => {
    setServices((prev) =>
      prev?.map((s) =>
        s.id === serviceId
          ? {
              ...s,
              ui: {
                ...s.ui,
                images: s.ui.images?.filter((_, i) => i !== index),
                previews: s.ui.previews?.filter((_, i) => i !== index),
              },
            }
          : s,
      ),
    );
  };

  const [selectedTab, setSelectedTab] = useState("all");

  // paginations functions
  const [page, setPage] = useState(0);

  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 10,
  });

  // table columns

  const columns = [
    {
      field: "id",
      headerName: "Request ID",
      flex: 1.3,
      minWidth: 140,
      renderCell: (params) => (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            height: "100%",
            gap: "4px",
          }}
        >
          <Tooltip
            title={`Request ID: #${params.row.id}`}
            placement="top"
            arrow
          >
            <span
              style={{
                fontSize: "12px",
                fontWeight: 600,
                color: "#444",
                backgroundColor: "#f0f0f06b",
                border: "1px solid #e0e0e0",
                borderRadius: "6px",
                padding: "2px 6px",
                cursor: "default",
                maxWidth: "200px",
                overflow: "hidden",
                textOverflow: "ellipsis",
                display: "block",
              }}
            >
              {params.row.reference || `#${params.row.id}`}
            </span>
          </Tooltip>
          {(params.row.is_read == "0" || newRequestIds.has(params.row.id)) &&
            !updatedStatusIds.has(params.row.id) && (
              <span className="new-badge">NEW</span>
            )}
        </div>
      ),
    },
    {
      field: "client",
      headerName: "Client Name",
      flex: 1,
      minWidth: 120,
      renderCell: (params) =>
        params.row?.client?.name ? (
          <div
            style={{ height: "100%", display: "flex", alignItems: "center" }}
          >
            <div className=" d-flex justify-content-start align-items-center gap-1">
              <img
                src={
                  params.row?.client?.profile_photo
                    ? `${newImageUrl}${params.row?.client?.profile_photo}`
                    : defaultImg
                }
                width={30}
                height={30}
                style={{ borderRadius: "50%" }}
                alt=""
              />
              <span>{params.row?.client?.name}</span>
            </div>
          </div>
        ) : (
          <span>-</span>
        ),
    },
    {
      field: "car",
      headerName: "Car Model",
      flex: 0.9,
      minWidth: 120,
      renderCell: (params) =>
        params.row?.client?.car ? params.row?.client?.car : "-",
    },
    {
      field: "phone",
      headerName: "Mobile Number",
      flex: 0.9,
      minWidth: 120,
      renderCell: (params) =>
        params.row?.client?.phone ? params.row?.client?.phone : "-",
    },
    {
      field: "services",
      headerName: "Services",
      flex: 0.9,
      minWidth: 120,
      renderCell: (params) => `${params.row?.services_count} services`,
    },
    {
      field: "created_at",
      headerName: "Date",
      flex: 0.9,
      minWidth: 120,
      renderCell: (params) =>
        new Date(params.row?.created_at).toLocaleDateString(),
    },
    {
      field: "status",
      headerName: "Status",
      flex: 0.9,
      minWidth: 150,
      renderCell: (params) => {
        const isUpdated = updatedStatusIds.has(params.row.id);
        const transition = statusTransitions[params.row.id];

        return (
          <div
            style={{
              height: "100%",
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: "4px 8px",
              borderRadius: "10px",
              backgroundColor: isUpdated
                ? "rgba(62,173,163,0.07)"
                : "transparent",
              animation: isUpdated ? "statusCellPulse 0.8s ease both" : "none",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: "5px",
                width: "100%",
              }}
            >
              {isUpdated && transition && (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "4px",
                  }}
                >
                  <span
                    style={{
                      fontSize: "9px",
                      color: "#bbb",
                      fontWeight: 600,
                      letterSpacing: "0.5px",
                      textTransform: "uppercase",
                    }}
                  >
                    was
                  </span>
                  <div
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      gap: "4px",
                      backgroundColor: "#f5f5f5",
                      border: "1px solid #e0e0e0",
                      borderRadius: "20px",
                      padding: "2px 8px",
                    }}
                  >
                    {transition.oldIcon && (
                      <img
                        src={transition.oldIcon}
                        alt=""
                        style={{
                          width: "11px",
                          height: "11px",
                          objectFit: "contain",
                          filter: "grayscale(1)",
                          opacity: 0.45,
                        }}
                      />
                    )}
                    <span
                      style={{
                        fontSize: "10px",
                        fontWeight: 600,
                        color: "#bbb",
                        whiteSpace: "nowrap",
                        textDecoration: "line-through",
                      }}
                    >
                      {transition.oldName}
                    </span>
                  </div>
                </div>
              )}

              {/* الجديدة — بيحصلها animation */}
              <div
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "6px",
                  backgroundColor: isUpdated
                    ? "rgba(62,173,163,0.13)"
                    : "#f5f5f5",
                  border: `1.5px solid ${isUpdated ? "#3EADA3" : "#e0e0e0"}`,
                  borderRadius: "20px",
                  padding: "4px 10px",
                  transition:
                    "background-color 0.4s ease, border-color 0.4s ease",
                  animation: isUpdated
                    ? "statusNewPop 0.5s ease both, statusGlowPulse 0.8s ease 0.3s both"
                    : "none",
                }}
              >
                <img
                  src={params.row?.status?.icon || defaultImg}
                  alt=""
                  style={{
                    width: "14px",
                    height: "14px",
                    objectFit: "contain",
                    animation: isUpdated
                      ? "statusIconBounce 0.5s ease 0.15s both"
                      : "none",
                  }}
                />
                <span
                  style={{
                    fontWeight: 600,
                    fontSize: "11px",
                    color: isUpdated ? "#3EADA3" : "#444",
                    whiteSpace: "nowrap",
                    transition: "color 0.3s ease",
                  }}
                >
                  {params.row?.status?.name || "-"}
                </span>
              </div>
            </div>
          </div>
        );
      },
    },
    {
      field: "actions",
      headerName: "Actions",
      flex: 0.9,
      minWidth: 120,
      sortable: false,
      renderCell: (params) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "4px",
            height: "100%",
          }}
        >
          {params.row?.is_read == "1" && (
            <Tooltip title="Mark as unread">
              <IconButton
                disableRipple
                size="small"
                onClick={(e) => toggleRead(params.row.id, e)}
                sx={{ color: "text.secondary" }}
              >
                <VisibilityOffOutlined fontSize="small" />
              </IconButton>
            </Tooltip>
          )}

          {/* السهم */}
          <Tooltip
            title={params.row?.is_read == "0" ? "View & mark as read" : "View"}
          >
            <IconButton
              disableRipple
              size="small"
              onClick={(e) => {
                handleRequestShow(params.row);
                setUpdatedStatusIds((prev) => {
                  const next = new Set(prev);
                  next.delete(params.row.id);
                  return next;
                });
                e.stopPropagation();
              }}
              sx={{
                color: params.row?.is_read == "0" ? "primary.main" : "inherit",
              }}
            >
              <ArrowForwardIosOutlined fontSize="small" />
            </IconButton>
          </Tooltip>
        </div>
      ),
    },
  ];

  useEffect(() => {
    getUserRequests();
  }, [selectedTab, searchQuery, filterDate, page]);

  useEffect(() => {
    getRequestStatuses();
  }, []);

  useEffect(() => {
    let data = [...userRequests];

    if (selectedTab !== "all") {
      data = data.filter((item) => item.status_id == selectedTab);
    }

    if (filterDate) {
      data = data.filter((item) => {
        const itemDate = new Date(item.created_at).toISOString().split("T")[0];
        return itemDate === filterDate;
      });
    }

    if (searchQuery.trim() !== "") {
      const search = searchQuery.toLowerCase();
      data = data.filter(
        (item) =>
          item.id.toString().includes(search) ||
          item.client?.name?.toLowerCase().includes(search),
      );
    }

    setFilteredRequests(data);
    setPaginationModel((prev) => ({ ...prev, page: 0 }));
  }, [userRequests, selectedTab, searchQuery, filterDate]);

  // Handle request status conditions
  const totalPrice = services.reduce((sum, service) => {
    if (service.ui?.isAccepted && service.ui.productPrice || service.ui?.isAccepted && service.ui.serviceFee ) {
      return sum + Number(service.ui.productPrice) + Number(service.ui.serviceFee);
    }
    return sum;
  }, 0);

  const acceptedCount = services.filter(
    (s) => s.ui.isAccepted + s.ui.isRejected,
  ).length;

  const [expireDate, setExpireDate] = useState(dayjs().add(1, "day"));
  const statusName = requestDetails.status?.name;

  const isPending = statusName === "pending";
  const isCancelled = statusName === "cancelled";
  const isExpired = statusName === "expired";

  const acceptedWithPriceCount = services.filter(
    (s) => s.ui.isAccepted && Number(s.ui.productPrice) > 0 ||  s.ui.isAccepted && Number(s.ui.serviceFee),
  ).length;

  const shouldShowPriceSection = isPending && acceptedWithPriceCount > 0;
 
  const hasOverLimitText = services.some((service) => {
    const notesOver =
      service.ui.isAccepted &&
      service.ui.notes &&
      service.ui.notes.length > 500;

    const rejectOver =
      service.ui.isRejected &&
      service.ui.rejectReason &&
      service.ui.rejectReason.length > 500;

    return notesOver || rejectOver;
  });

  const [openImage, setOpenImage] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  const getDraftKey = (requestId) => `doorstep_request_draft_${requestId}`;

  const saveDraft = () => {
    if (!requestDetails?.id) return;

    const draftData = {
      services,
      expireDate: expireDate ? dayjs(expireDate).toISOString() : null,
    };

    sessionStorage.setItem(
      getDraftKey(requestDetails.id),
      JSON.stringify(draftData),
    );

    toast.success("Draft saved locally");
  };

  useEffect(() => {
    if (!requestDetails?.id) return;
    if (!isPending) return;

    const timeout = setTimeout(() => {
      const draftData = {
        services,
        expireDate,
      };

      sessionStorage.setItem(
        getDraftKey(requestDetails.id),
        JSON.stringify(draftData),
      );
    }, 800);

    return () => clearTimeout(timeout);
  }, [services, expireDate]);

  const autoOpenedRef = useRef(false);

  useEffect(() => {
    if (!id || filteredRequests.length === 0 || autoOpenedRef.current) return;

    const targetRow = filteredRequests.find((r) => r.id === Number(id));
    if (targetRow) {
      autoOpenedRef.current = true;
      handleRequestShow(targetRow);
    }
  }, [id, filteredRequests])



     // ****************** firbase ************************

  const [newRequestIds, setNewRequestIds] = useState(new Set());
  const [updatedStatusIds, setUpdatedStatusIds] = useState(() => {
    const stored = sessionStorage.getItem("updatedStatusIds");
    return stored ? new Set(JSON.parse(stored)) : new Set();
  });

  const [statusTransitions, setStatusTransitions] = useState(() => {
    const stored = sessionStorage.getItem("statusTransitions");
    return stored ? JSON.parse(stored) : {};
  });

  const pageOpenTime = useRef(Date.now());

  const requestDetailsIdRef = useRef(requestDetails.id);
  useEffect(() => {
    requestDetailsIdRef.current = requestDetails.id;
  }, [requestDetails.id]);

  const toggleRead = async (requestId, e) => {
    e.stopPropagation();
    try {
      await axios.post(
        `${newHost}portal/door_step_request_others/${requestId}/toggle-read`,
        {},
        { headers: { Authorization: `Bearer ${token}` } },
      );
      setUserRequests((prev) =>
        prev.map((r) =>
          r.id === requestId
            ? { ...r, is_read: r.is_read == "1" ? "0" : "1" }
            : r,
        ),
      );

      setNewRequestIds((prev) => {
        const next = new Set(prev);
        next.delete(requestId);
        return next;
      });

      setUpdatedStatusIds((prev) => {
        const next = new Set(prev);
        next.delete(requestId);
        sessionStorage.setItem("updatedStatusIds", JSON.stringify([...next]));
        return next;
      });
      setStatusTransitions((prev) => {
        const next = { ...prev };
        delete next[requestId];
        return next;
      });
      setStatusTransitions((prev) => {
        const next = { ...prev };
        delete next[requestId];
        sessionStorage.setItem("statusTransitions", JSON.stringify(next));
        return next;
      });
    } catch (error) {
      toast.error("Failed to update read status");
    }
  };

  const getRequest = async (requestId) => {
    try {
      const response = await axios.get(
        `${newHost}portal/door_step_request_others/${requestId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      const updatedRequest = response.data.data.other_request;
      if (!updatedRequest) return;

      if (requestDetailsIdRef.current === updatedRequest.id) {
        setRequestDetails(updatedRequest);

        const servicesWithUI = updatedRequest.services.map((service) => ({
          ...service,
          ui: {
            isAccepted: false,
            isRejected: false,
            productPrice: "",
            serviceFee: "",
            notes: "",
            estimated_time: "",
            rejectReason: "",
          },
        }));
        setServices(servicesWithUI);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (!token) return;
    const pageOpenTime = Date.now();
    const liveRef = query(ref(database, "other_requests"), limitToLast(5));
    const unsubscribe = onChildAdded(liveRef, (snapshot) => {
      const data = snapshot.val();
      const recordTime = new Date(data.created_at).getTime();
      if (recordTime < pageOpenTime) return;
      setTimeout(() => {
        axios
          .get(`${newHost}portal/door_step_request_others/${data.id}`, {
            headers: { Authorization: `Bearer ${token}` },
          })
          .then((res) => {
            const newRequest = res.data.data.other_request;
            if (!newRequest) return;
            setUserRequests((prev) => {
              if (prev.find((r) => r.id === newRequest.id)) return prev;
              return [...prev, newRequest];
            });
            setNewRequestIds((prev) => new Set([...prev, newRequest.id]));
          })
          .catch(console.error);
      }, 8000);
    });
    return () => unsubscribe();
  }, [token]);

  useEffect(() => {
    if (!token || !requestStatuses.length) return;

    const statusRef = ref(database, "status_updated/other_requests");

    const handleStatusUpdate = (snapshot) => {
      const requestId = Number(snapshot.key);
      const data = snapshot.val();
      if (!data?.updated_at) return;

      const recordTime = new Date(data.updated_at).getTime();
      if (recordTime < pageOpenTime.current) return;

      const newStatus = requestStatuses.find((s) => s.id === data.status);
      if (!newStatus) return;

      setUserRequests((prev) => {
        const current = prev.find((o) => o.id === requestId);
        if (current) {
          setStatusTransitions((t) => {
            const next = {
              ...t,
              [requestId]: {
                oldName: current.status?.name || "-",
                oldIcon: current.status?.icon,
              },
            };
            sessionStorage.setItem("statusTransitions", JSON.stringify(next));
            return next;
          });
        }
        return prev.map((order) =>
          order.id === requestId
            ? {
                ...order,
                status: {
                  ...order.status,
                  name: newStatus.name,
                  icon: newStatus.image_url,
                  color: newStatus.color,
                  border_color: newStatus.border_color,
                },
              }
            : order,
        );
      });

      setUpdatedStatusIds((prev) => {
        const next = new Set([...prev, requestId]);
        sessionStorage.setItem("updatedStatusIds", JSON.stringify([...next]));
        return next;
      });

      if (
        ["approved", "partially_approved", "cancelled"].includes(
          newStatus.name,
        )
      ) {
        getRequest(requestId);
      }
    };

    const unsub1 = onChildAdded(
      query(statusRef, limitToLast(1)),
      handleStatusUpdate,
    );

    const unsub2 = onChildChanged(statusRef, handleStatusUpdate);

    return () => {
      unsub1();
      unsub2();
    };
  }, [token, requestStatuses]);

  // ****************** firbase ************************

  return (
    <>
      {/* Request Side */}
      <Drawer
        anchor="right"
        open={requestShow}
        onClose={handleRequestClose}
        PaperProps={{
          sx: {
            borderTopLeftRadius: 13,
            borderBottomLeftRadius: 13,
            overflow: "hidden",
          },
        }}
      >
        <Box
          sx={{
            width: { xs: "100vw", sm: 700 },
            height: "100%",
            display: "flex",
            flexDirection: "column",
            overflowX: "hidden",
          }}
        >
          {/*HEADER*/}
          <Box
            sx={{
              p: 2,
              borderBottom: "1px solid #eee",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <div className="d-flex gap-3 align-items-center">
              <Typography
                variant="h6"
                className="text-black d-flex gap-3 align-items-center"
              >
                Request #{requestDetails.id}
              </Typography>
              <div className="d-flex justify-content-center align-items-center gap-1 px-3 rounded-4">
                <div className="" style={{ width: "20px", height: "" }}>
                  <img
                    src={
                      requestDetails.status?.icon
                        ? requestDetails.status?.icon
                        : defaultImg
                    }
                    alt=""
                    style={{
                      width: "100%",
                      height: "100%",
                    }}
                  />
                </div>
                <div
                  style={{
                    backgroundColor: "",
                    fontWeight: 600,
                    fontSize: "16px",
                  }}
                  className="main-text-color"
                >
                  {requestDetails.status?.name}
                </div>
              </div>
            </div>
            <IconButton onClick={handleRequestClose}>
              <CloseIcon />
            </IconButton>
          </Box>

          <Box
            sx={{
              flex: 1,
              px: 0,
            }}
          >
            {/* Request Header */}
            <div className="border-bottom my-1">
              <div className="py-2">
                <div className="row">
                  <div className="col-12 col-md-6">
                    <div className="mx-4">
                      <h6
                        style={{
                          fontSize: "14px",
                        }}
                        className="main-text-color "
                      >
                        Client Name
                      </h6>
                      <div className="d-flex gap-2 align-items-center">
                        <img
                          style={{ width: "30px", height: "30px" }}
                          src={
                            requestDetails?.client?.profile_photo
                              ? `${newImageUrl}${requestDetails?.client?.profile_photo}`
                              : defaultImg
                          }
                          alt=""
                          className={`${requestDetails?.client?.profile_photo ? "rounded-5" : ""}`}
                        />
                        <h6 className="m-0 fw-semibold">
                          {requestDetails.client?.name}
                        </h6>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-6">
                    <h6
                      style={{
                        fontSize: "14px",
                      }}
                      className="main-text-color "
                    >
                      Mobile Number
                    </h6>
                    <h6 className="my-3">{requestDetails.client?.phone}</h6>
                  </div>
                </div>
                <div className="row my-2">
                  <div className="col-12 col-md-6">
                    <div className="mx-4">
                      <h6
                        style={{
                          fontSize: "14px",
                        }}
                        className="main-text-color "
                      >
                        Time
                      </h6>
                      <h6 className="my-3">
                        {new Date(
                          requestDetails?.created_at,
                        ).toLocaleDateString()}
                      </h6>
                    </div>
                  </div>
                  <div className="col-12 col-md-6">
                    <h6
                      style={{
                        fontSize: "14px",
                      }}
                      className="main-text-color "
                    >
                      Services Number
                    </h6>
                    <h6 className="my-3">{`${requestDetails.services_count} services`}</h6>
                  </div>
                </div>
                <div className="row my-2">
                  <div className="col-12 col-md-6">
                    <div className="w-100 mx-4">
                      <h6
                        style={{
                          fontSize: "14px",
                        }}
                        className="main-text-color "
                      >
                        Expiry Date
                      </h6>
                      {isPending ? (
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
  <DemoContainer components={["DateTimePicker"]}>
    <DateTimePicker
      sx={{ width: "25%" }}
      className="m-0"
      format="DD,MM,YYYY HH:mm"
      slotProps={{
        textField: {
          size: "small",
          placeholder: "Select Date",
        },
      }}
      value={expireDate}
      onChange={(date) => setExpireDate(date)}
    />
  </DemoContainer>
</LocalizationProvider>
                      ) : requestDetails.pricing?.expire_date ? (
                        <h6 className="my-3">{`${new Date(requestDetails.pricing?.expire_date).toLocaleDateString()}, ${new Date(requestDetails.pricing?.expire_date).toLocaleTimeString()}`}</h6>
                      ) : (
                        <>
                          <span>-</span>
                        </>
                      )}
                    </div>
                  </div>
                  <div className="col-12 col-md-6">
                    <h6
                      style={{
                        fontSize: "14px",
                      }}
                      className="main-text-color "
                    >
                      Estimated Time
                    </h6>
                    <h6 className="my-3">{`${requestDetails.pricing?.total_estimated_time} min`}</h6>
                  </div>
                </div>
              </div>
            </div>

            {/* Requests services */}
            {isPending ? (
              <>
                {services.map((service, index) => (
                  <div key={service.id} className="my-2 p-3">
                    <h6 className="main-text-color">Service {index + 1}</h6>

                    <div
                      className="mt-3 p-3 rounded-2"
                      style={{
                        backgroundColor: "#F8F8F899",
                        border: "1px solid #C6C6C633",
                      }}
                    >
                      <div className="d-flex gap-2">
                        <button
                          onClick={() => handleAccept(service.id)}
                          className={`btn-accept ${
                            service.ui.isAccepted || service.ui.isRejected
                              ? "d-none"
                              : ""
                          }`}
                        >
                          Accept
                        </button>

                        <button
                          onClick={() => handleReject(service.id)}
                          className={`btn-reject ${
                            service.ui.isAccepted ? "d-none" : ""
                          }`}
                        >
                          Reject
                        </button>

                        {service.ui.isAccepted && (
                          <>
                            <button onClick={() => handleReset(service.id)}>
                              <TurnLeft
                                sx={{ color: "#696969", fontWeight: "300" }}
                              />
                            </button>
                            <button className="btn-accept">Accept</button>
                          </>
                        )}

                        {service.ui.isRejected && (
                          <button onClick={() => handleReset(service.id)}>
                            <TurnLeft
                              sx={{ color: "#696969", fontWeight: "300" }}
                            />
                          </button>
                        )}
                      </div>

                      {/* DETAILS */}
                      <div className="d-flex justify-content-end">
                        <div className="text-end">
                          {/* <h6 className="fw-bold">{service.title}</h6> */}
                          <ReadMoreTitle text={service.title} maxChars={80} />
                          <ReadMoreChars
                            text={service.description}
                            maxChars={150}
                          />
                          <div className="d-flex gap-3 align-items-center justify-content-end my-2 w-100 flex-wrap">
                            {service?.client_images?.length > 0 ? (
                              service?.client_images?.map(
                                (serviceImg, index) => (
                                  <div
                                    key={index}
                                    style={{
                                      width: "130px",
                                      height: "85px",
                                      backgroundColor: "#FFFFFF",
                                    }}
                                    className="rounded-2 p-2 border"
                                  >
                                    <img
                                      className="w-100 h-100"
                                      src={serviceImg?.full_image_url}
                                      alt=""
                                      style={{
                                        cursor: "pointer",
                                        objectFit: "fill",
                                      }}
                                      onClick={() => {
                                        setSelectedImage(
                                          serviceImg?.full_image_url,
                                        );
                                        setOpenImage(true);
                                      }}
                                    />
                                  </div>
                                ),
                              )
                            ) : (
                              <div
                                style={{
                                  width: "130px",
                                  height: "85px",
                                  backgroundColor: "#FFFFFF",
                                }}
                                className="rounded-2 p-2 border"
                              >
                                <img
                                  className="w-100 h-100"
                                  src={defaultImg}
                                  alt=""
                                  style={{ objectFit: "fill" }}
                                />
                              </div>
                            )}
                          </div>
                          <Dialog
                            open={openImage}
                            onClose={() => setOpenImage(false)}
                            fullScreen
                            PaperProps={{
                              sx: {
                                backgroundColor: "rgba(0,0,0,0.95)",
                              },
                            }}
                          >
                            <IconButton
                              onClick={() => setOpenImage(false)}
                              sx={{
                                position: "absolute",
                                top: 16,
                                right: 16,
                                color: "#fff",
                                zIndex: 10,
                              }}
                            >
                              <CloseIcon fontSize="large" />
                            </IconButton>
                            <IconButton
                              onClick={() => setOpenImage(false)}
                              sx={{
                                position: "absolute",
                                top: 16,
                                left: 16,
                                color: "#fff",
                                zIndex: 10,
                              }}
                            >
                              <ArrowBackIcon fontSize="large" />
                            </IconButton>

                            <Box
                              sx={{
                                width: "100vw",
                                height: "100vh",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <img
                                src={selectedImage}
                                alt=""
                                style={{
                                  maxWidth: "100%",
                                  maxHeight: "500px",
                                  objectFit: "contain",
                                }}
                              />
                            </Box>
                          </Dialog>
                        </div>
                      </div>

                      {/* ACCEPT */}
                      {service.ui.isAccepted && (
                        <>
                   <div className="my-2">
                         <label className="main-text-color label-size" htmlFor="productPrice">Product Price <span className="text-danger fs-6">*</span></label>
                          <TextField
                           id="productPrice"
                            type="number"
                            size="small"
                            className="w-100 my-1"
                            placeholder="product price"
                            value={service.ui.productPrice}
                            onChange={(e) =>
                              setServices((prev) =>
                                prev.map((s) =>
                                  s.id === service.id
                                    ? {
                                        ...s,
                                        ui: { ...s.ui, productPrice: e.target.value },
                                      }
                                    : s,
                                ),
                              )
                            }
                          />
                   </div>
                      <div className="my-2">
                            <label className="main-text-color label-size" htmlFor="serviceFee">Service Fee <span className="text-danger fs-6">*</span></label>
                          <TextField
                            id="serviceFee"
                            type="number"
                            size="small"
                            className="w-100 my-1"
                            placeholder="service fee"
                            value={service.ui.serviceFee}
                            onChange={(e) =>
                              setServices((prev) =>
                                prev.map((s) =>
                                  s.id === service.id
                                    ? {
                                        ...s,
                                        ui: { ...s.ui, serviceFee: e.target.value },
                                      }
                                    : s,
                                ),
                              )
                            }
                          />

                      </div>
                      <div className="my-2">
                        <label htmlFor="estbnNote" className="main-text-color label-size">Estbn Note</label>
  <LimitedTextarea labelId={"estbnNote"}
                            value={service.ui.notes}
                            maxLength={500}
                            placeholder="Notes"
                            onChange={(e) =>
                              setServices((prev) =>
                                prev.map((s) =>
                                  s.id === service.id
                                    ? {
                                        ...s,
                                        ui: { ...s.ui, notes: e.target.value },
                                      }
                                    : s,
                                ),
                              )
                            }
                          />
                      </div>
                        <div className="my-2">

                        </div>
                          <label htmlFor="estimatedTime" className="main-text-color label-size">Estimated Time <span className="text-danger fs-6">*</span></label>
                          <Form.Group className="mb-3">
                            <Form.Control
                            id="estimatedTime"
                              type="number"
                              min="0"
                              size="sm"
                              placeholder="Add estimated time in minutes"
                              value={service.ui.estimated_time}
                              onChange={(e) =>
                                setServices((prev) =>
                                  prev.map((s) =>
                                    s.id == service.id
                                      ? {
                                          ...s,
                                          ui: {
                                            ...s.ui,
                                            estimated_time: e.target.value,
                                          },
                                        }
                                      : s,
                                  ),
                                )
                              }
                              className="add-service-input"
                            />
                          </Form.Group>
                          <div className="row my-2">
                            {service.ui?.previews?.map((img, index) => (
                              <div key={index} className="col-md-4 my-2">
                                <div className="image-wrapper position-relative">
                                  <img
                                    src={img}
                                    className="custom-images-url rounded"
                                  />

                                  <CancelIcon
                                    className="remove-icon"
                                    onClick={() =>
                                      handleRemoveImage(service.id, index)
                                    }
                                  />
                                </div>
                              </div>
                            ))}

                            {/* Add Image Box */}
                            <div className="col-md-4 my-2">
                              <label
                                htmlFor={`estbn-img-${service.id}`}
                                style={{
                                  border: "dashed 1px #C6C6C6",
                                  width: "100%",
                                  height: "120px",
                                  cursor: "pointer",
                                  borderRadius: "5px",
                                }}
                                className="d-flex flex-column justify-content-center align-items-center p-2"
                              >
                                <img
                                  src={cameraIcon}
                                  style={{ width: "40px" }}
                                />
                                <p className="main-text-color label-size m-0">
                                  Add Image
                                </p>

                                <input
                                  type="file"
                                  multiple
                                  className="d-none"
                                  id={`estbn-img-${service.id}`}
                                  onChange={(e) =>
                                    handleFileChange(e, service.id)
                                  }
                                />
                              </label>
                            </div>
                          </div>
                        </>
                      )}

                      {/* REJECT */}
                      {service.ui.isRejected && (
            <div className="m-2">
                          <label htmlFor="rejectReason" className="main-text-color label-size">Reject Reason</label>
                        <LimitedTextarea
                         labelId={"rejectReason"}
                          value={service.ui.rejectReason}
                          maxLength={500}
                          placeholder="Reject reason"
                          onChange={(e) =>
                            setServices((prev) =>
                              prev.map((s) =>
                                s.id === service.id
                                  ? {
                                      ...s,
                                      ui: {
                                        ...s.ui,
                                        rejectReason: e.target.value,
                                      },
                                    }
                                  : s,
                              ),
                            )
                          }
                        />
            </div>
                      )}
                    </div>
                  </div>
                ))}
              </>
            ) : (
              <>
                {services.map((service, index) => (
                  <div key={service.id} className="my-2 p-3">
                    <h6 className="main-text-color">Service {index + 1}</h6>
                    <div
                      className="my-2 p-3 rounded-2"
                      style={{
                        backgroundColor: "#F8F8F899",
                        border: "1px solid #C6C6C633",
                      }}
                    >
                      <div className="mt-3">
                        {service.status === "rejected_by_user" ? (
                          <>
                            <span className="btn-reject px-4">
                              User Rejected <Cancel sx={{ color: "#A80101" }} />
                            </span>
                          </>
                        ) : service.status === "rejected_by_admin" ? (
                          <>
                            <span className="btn-reject px-4">
                              Admin Rejected{" "}
                              <Cancel sx={{ color: "#A80101" }} />{" "}
                            </span>
                          </>
                        ) : service.status === "accepted_by_user" ? (
                          <>
                            <span className="btn-accept px-4">
                              User Accepted{" "}
                              <CheckCircleIcon sx={{ color: "#3FBEAC" }} />{" "}
                            </span>
                          </>
                        ) : service.status === "accepted_by_admin" ? (
                          <>
                            {" "}
                            <span className="btn-accept px-4">
                              {" "}
                              Admin Accepted{" "}
                              <CheckCircleIcon sx={{ color: "#3FBEAC" }} />
                            </span>
                          </>
                        ) : null}
                      </div>
                      {/* DETAILS */}
                      <div className="d-flex justify-content-end">
                        <div className="text-end">
                          <ReadMoreTitle text={service.title} maxChars={50} />
                          <ReadMoreChars
                            text={service.description}
                            maxChars={150}
                          />

                          <div className="d-flex gap-3 align-items-center justify-content-end my-2 w-100">
                            {service.client_images?.length > 0 ? (
                              service.client_images?.map(
                                (serviceImg, index) => (
                                  <div
                                    key={index}
                                    style={{
                                      width: "130px",
                                      height: "85px",
                                      backgroundColor: "#FFFFFF",
                                      cursor: "pointer",
                                    }}
                                    className="rounded-2 p-2 border"
                                    onClick={() => {
                                      setSelectedImage(
                                        serviceImg?.full_image_url,
                                      );
                                      setOpenImage(true);
                                    }}
                                  >
                                    <img
                                      className="w-100 h-100"
                                      src={serviceImg?.full_image_url}
                                      alt=""
                                      style={{
                                        objectFit: "fill",
                                        borderRadius: "6px",
                                      }}
                                    />
                                  </div>
                                ),
                              )
                            ) : (
                              <div
                                style={{
                                  width: "130px",
                                  height: "85px",
                                  backgroundColor: "#FFFFFF",
                                }}
                                className="rounded-2 p-2 border"
                              >
                                <img
                                  className="w-100 h-100"
                                  src={defaultImg}
                                  alt=""
                                  style={{
                                    objectFit: "fill",
                                    borderRadius: "6px",
                                  }}
                                />
                              </div>
                            )}

                            <Dialog
                              open={openImage}
                              onClose={() => setOpenImage(false)}
                              fullScreen
                              PaperProps={{
                                sx: { backgroundColor: "rgba(0,0,0,0.95)" },
                              }}
                            >
                              <IconButton
                                onClick={() => setOpenImage(false)}
                                sx={{
                                  position: "absolute",
                                  top: 16,
                                  right: 16,
                                  color: "#fff",
                                  zIndex: 10,
                                }}
                              >
                                <CloseIcon fontSize="large" />
                              </IconButton>
                              <IconButton
                                onClick={() => setOpenImage(false)}
                                sx={{
                                  position: "absolute",
                                  top: 16,
                                  left: 16,
                                  color: "#fff",
                                  zIndex: 10,
                                }}
                              >
                                <ArrowBackIcon fontSize="large" />
                              </IconButton>

                              <Box
                                sx={{
                                  width: "100vw",
                                  height: "100vh",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                              >
                                <img
                                  src={selectedImage}
                                  alt=""
                                  style={{
                                    maxWidth: "100%",
                                    maxHeight: "500px",
                                    objectFit: "contain",
                                  }}
                                />
                              </Box>
                            </Dialog>
                          </div>
                          {service?.estbn_images?.length > 0 ? (
                            <div s className="my-3 text-start  w-100 ">
                              <h6 className="main-text-color label-size">
                                Estbn images
                              </h6>
                              <div className="d-flex gap-2 align-items-center flex-wrap">
                                {service?.estbn_images?.map(
                                  (estbnImg, indx) => (
                                    <div
                                      key={indx}
                                      style={{
                                        width: "130px",
                                        height: "85px",
                                        backgroundColor: "#FFFFFF",
                                        cursor: "pointer",
                                      }}
                                      className="rounded-2 p-2 border"
                                      onClick={() => {
                                        setSelectedImage(
                                          estbnImg?.full_image_url,
                                        );
                                        setOpenImage(true);
                                      }}
                                    >
                                      <img
                                        className="w-100 h-100"
                                        src={estbnImg?.full_image_url}
                                        alt=""
                                        style={{
                                          objectFit: "fill",
                                          borderRadius: "6px",
                                        }}
                                      />
                                    </div>
                                  ),
                                )}
                              </div>
                            </div>
                          ) : null}
                        </div>
                      </div>
                      <div className="my-2">
                        <div className="">
                          <h6 className="main-text-color label-size">
                            Product Price
                          </h6>
                          <p className="fw-semibold">
                         {  `${Number(service.product_price)?.toLocaleString("en-US")} L.E `}
                          </p>
                        </div>
                        <div className="">
                          <h6 className="main-text-color label-size">
                            Service Fee
                          </h6>
                          <p className="fw-semibold">
                         {`${Number(service.service_fee)?.toLocaleString("en-US")} L.E `}                              
                          </p>
                        </div>

                        <div className="">
                          <h6 className="main-text-color label-size">
                            Estimated Time
                          </h6>
                          <p className="fw-semibold">{`${service.estimated_time} min`}</p>
                        </div>
                        <div className="">
                          <h6 className="main-text-color label-size">
                            ESTBN Notes
                          </h6>
                          <div style={{ direction: "rtl" }} className="">
                            <ReadMoreChars
                              text={
                                service.estbn_notes
                                  ? `${service.estbn_notes}`
                                  : "-"
                              }
                              maxChars={150}
                            />
                          </div>
                        </div>
                        <div className="">
                          <h6 className="main-text-color label-size">
                            Reject Reason
                          </h6>
                          <div style={{ direction: "rtl" }} className="">
                            <ReadMoreChars
                              text={
                                service.reject_reason
                                  ? `${service.reject_reason}`
                                  : "-"
                              }
                              maxChars={150}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </>
            )}
          </Box>

          {/* Submit Requests */}

          {isCancelled ? (
            <div className="fixed-footer-wrapper">
              <div className="fixed-footer-cancel">
                <div className="d-flex align-items-center gap-2">
                  <InfoIcon sx={{ color: "#A80101" }} />
                  <h6 className="m-0">Reason for Rejection:</h6>
                </div>

                <div className="my-2">
                  <ReadMoreChars
                    text={
                      requestDetails.reject_reason
                        ? requestDetails.reject_reason
                        : "No comment"
                    }
                    maxChars={150}
                  />
                </div>
              </div>
              <div className="fixed-footer-total-price">
                {!isPending && (
                  <div
                    style={{ backgroundColor: "#EFEFEF" }}
                    className="my-2 p-3 rounded-2"
                  >
                    <div className="d-flex align-items-center justify-content-between pb-2 ">
                      <h6 className="m-0">Total Services Price:</h6>

                      <h6 className="fw-bold m-0">
                        {`${Number(requestDetails.pricing?.total_services_price)?.toLocaleString("en-US")} L.E`}
                      </h6>
                    </div>
                    <div className="d-flex align-items-center justify-content-between py-2 ">
                      <h6 className="fw-bold m-0">Customer Final Cost:</h6>

                      <h6 className="fw-bold m-0">
                        {`${Number(requestDetails.pricing?.total_price)?.toLocaleString("en-US")} L.E`}
                      </h6>
                    </div>
                  </div>
                )}
              </div>
            </div>
          ) : isExpired ? (
            <>
              <div className="fixed-footer-wrapper">
                <div className="fixed-footer-expire">
                  <div className="d-flex align-items-center gap-2">
                    <InfoIcon sx={{ color: "#FEB91E" }} />
                    <h6 className="m-0">
                      Request expired. The expiration date has passed and prices
                      have changed.
                    </h6>
                  </div>
                </div>
                <div className="fixed-footer-total-price">
                  {!isPending && (
                    <div
                      style={{ backgroundColor: "#EFEFEF" }}
                      className="my-2 p-3 rounded-2"
                    >
                      <div className="d-flex align-items-center justify-content-between pb-2 ">
                        <h6 className="m-0">Total Services Price:</h6>

                        <h6 className="fw-bold m-0">
                          {`${Number(requestDetails.pricing?.total_services_price)?.toLocaleString("en-US")} L.E`}
                        </h6>
                      </div>
                      <div className="d-flex align-items-center justify-content-between py-2 ">
                        <h6 className="fw-bold m-0">Customer Final Cost:</h6>

                        <h6 className="fw-bold m-0">
                          {`${Number(requestDetails.pricing?.total_price)?.toLocaleString("en-US")} L.E`}
                        </h6>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </>
          ) : (
            <div className="mt-3 flex-column p-3 fixed-footer">
              {shouldShowPriceSection && (
                <div
                  style={{ backgroundColor: "#EFEFEF" }}
                  className="my-2 d-flex align-items-center justify-content-between p-3 rounded-2"
                >
                  <h6 className="m-0">Total Services Price:</h6>

                  <h6 className="fw-bold m-0">
                    {isPending
                      ? `${totalPrice.toLocaleString("en-US")} L.E`
                      : `${Number(requestDetails.pricing?.total_price)?.toLocaleString("en-US")} L.E`}
                  </h6>
                </div>
              )}
              {!isPending && (
                <div
                  style={{ backgroundColor: "#EFEFEF" }}
                  className="my-2 p-3 rounded-2"
                >
                  <div className="d-flex align-items-center justify-content-between pb-2 ">
                    <h6 className="m-0">Total Services Price:</h6>

                    <h6 className="fw-bold m-0">
                      {`${Number(requestDetails.pricing?.total_services_price)?.toLocaleString("en-US")} L.E`}
                    </h6>
                  </div>
                  <div className="d-flex align-items-center justify-content-between py-2 ">
                    <h6 className="fw-bold m-0">Customer Final Cost:</h6>

                    <h6 className="fw-bold m-0">
                      {`${Number(requestDetails.pricing?.total_price)?.toLocaleString("en-US")} L.E`}
                    </h6>
                  </div>
                </div>
              )}

              {isPending && (
                <div className="row">
                  <div className="col-md-6 col-12">
                    <button
                      disabled={
                        services.some(
                          (s) => !s.ui.isAccepted && !s.ui.isRejected,
                        ) || hasOverLimitText
                      }
                      onClick={submitServices}
                      className="w-100 btn btn-dark"
                    >
                      Send to user {acceptedCount} of {services.length} services
                    </button>
                  </div>
                  <div className="col-md-6 col-12">
                    <button
                      onClick={saveDraft}
                      className="w-100 btn btn-light fw-semibold"
                    >
                      Save as a draft
                    </button>
                  </div>
                </div>
              )}
            </div>
          )}
        </Box>
      </Drawer>
      <div className="m-4">
        {/* Header section */}
        <div className="">
          <h5 className="fw-semibold">User Requests - Other Services</h5>
        </div>
        {/* search & mark */}
        <div className=" d-flex justify-content-between align-items-center">
          {/* search */}
          <div className="d-flex align-items-center" style={{ width: "70%" }}>
            <div className="w-50 mt-1">
              <FormControl fullWidth variant="outlined" size="small">
                <OutlinedInput
                  id="search-orders"
                  placeholder="Search for Request ID, customer name, or date ..."
                  type="text"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  endAdornment={
                    <InputAdornment position="start">
                      <IconButton>
                        <Search />
                      </IconButton>
                    </InputAdornment>
                  }
                />
              </FormControl>
            </div>
            <div className="w-25 mb-2 mx-2 position-relative">
              <DatePickerDMY
                value={filterDate}
                onChange={(iso) => {
                  setFilterDate(iso);
                  setPage(0);
                }}
              />
              {/* <input
              type="date"
            
              className="date-input form-control"
              value={filterDate} 
              onChange={(e) => {
                setFilterDate(e.target.value);
                setPage(0);
              }}
            />

            {filterDate && (
              <button
                type="button"
                className="btn btn-sm btn-light position-absolute"
                style={{
                  right: "10px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  padding: "2px 6px",
                  fontSize: "12px",
                }}
                onClick={() => {
                  setFilterDate("");
                  setPage(0);
                }}
              >
                ✕
              </button>
            )} */}
            </div>
          </div>
          {/* mark all as read */}
        <div className='mb-2'>
        <MarkAllAsRead page="requests" onSuccess={() => getUserRequests()} />
        </div>
        </div>
        {/* tabs section */}
        <div
          className="tabs-section bg-light rounded-3 d-flex align-items-center my-3"
          style={{
            width: "fit-content",
            maxWidth: "100%",
            overflowX: "auto",
            whiteSpace: "nowrap",
            WebkitOverflowScrolling: "touch",
            height: "50px",
          }}
        >
          <Tabs
            value={selectedTab}
            onChange={(_, value) => setSelectedTab(value)}
          >
            <Tab value="all" label={`All (${userRequests.length})`} />

            {requestStatuses.map((st) => (
              <Tab
                sx={{ textTransform: "capitalize" }}
                key={st.id}
                value={st.id}
                label={`${st.name} (${st.requests_count})`}
              />
            ))}
          </Tabs>
        </div>
        {/* table data */}
        <div className="my-3">
          {filteredRequests.length > 0 ? (
            <div className="data-grid-small">
              <Paper sx={{ height: "auto", width: "100%" }}>
                <DataGrid
                  rows={[...filteredRequests].reverse()}
                  columns={columns}
                  initialState={{ pagination: { paginationModel } }}
                  pageSizeOptions={[5, 10, 20, 50]}
                  checkboxSelection
                  getRowClassName={(params) => {
                    const isStatusUpdated = updatedStatusIds.has(params.row.id);
                    const isUnread =
                      newRequestIds.has(params.row.id) ||
                      params.row?.is_read == "0";

                    if (isStatusUpdated) return "";
                    if (isUnread) return "new-sos-row";
                    return "";
                  }}
                  getRowHeight={() => "auto"}
                  sx={{
                    border: 0,
                    overflow: "hidden",
                    "& .MuiDataGrid-cell": {
                      py: 1,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    },
                    // ===== Checkbox Style =====
                    "& .MuiCheckbox-root": {
                      color: "rgba(0,0,0,0.3)",
                    },
                    "& .MuiCheckbox-root.Mui-checked, & .MuiCheckbox-root.MuiCheckbox-indeterminate":
                      {
                        color: "#3EADA3",
                      },
                    "& .MuiCheckbox-root.Mui-checked .MuiSvgIcon-root": {
                      backgroundColor: "#3EADA3",
                      borderRadius: "4px",
                    },
                    "& .MuiCheckbox-root.Mui-checked .MuiSvgIcon-root path": {
                      color: "#fff",
                    },
                  }}
                  slotProps={{
                    pagination: {
                      sx: {
                        justifyContent: "center",
                        display: "flex",
                        alignItems: "center",
                      },
                    },
                  }}
                />
              </Paper>
            </div>
          ) : (
            <div className="flex flex-column text-center">
              <img src={noData} alt="no-data" />
              <p style={{ color: "#535353" }} className="">
                No available user requests
              </p>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default OtherServices;
